"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconDetailsOrder = void 0;
var React = __importStar(require("react"));
var IconDetailsOrder = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M18.2549,21 C18.6659,21 18.9999,20.648 18.9999,20.215 L18.9999,7.976 L15.2439,7.976 C14.4999,7.976 13.9999,7.476 13.9999,6.732 L13.9999,3 L5.7449,3 C5.3339,3 4.9999,3.352 4.9999,3.785 L4.9999,20.215 C4.9999,20.648 5.3339,21 5.7449,21 L18.2549,21 Z M18.4719,6.976 L14.9999,3.062 L14.9999,6.732 C14.9999,6.939 15.0649,6.976 15.2439,6.976 L18.4719,6.976 Z M19.8739,7.049 C19.9549,7.141 19.9999,7.259 19.9999,7.381 L19.9999,20.215 C19.9999,21.199 19.2169,22 18.2549,22 L5.7449,22 C4.7829,22 3.9999,21.199 3.9999,20.215 L3.9999,3.785 C3.9999,2.801 4.7829,2 5.7449,2 L15.1699,2 C15.3129,2 15.4489,2.061 15.5439,2.168 L19.8739,7.049 Z M8,12 C8,13.654 9.346,15 11,15 C12.654,15 14,13.654 14,12 C14,10.346 12.654,9 11,9 C9.346,9 8,10.346 8,12 Z M13.895,14.749 L15.887,17.184 C16.062,17.397 16.03,17.712 15.816,17.887 C15.724,17.963 15.611,18 15.5,18 C15.355,18 15.212,17.937 15.113,17.816 L13.12,15.38 C12.504,15.767 11.781,16 11,16 C8.791,16 7,14.209 7,12 C7,9.791 8.791,8 11,8 C13.209,8 15,9.791 15,12 C15,13.067 14.575,14.031 13.895,14.749 Z" }))); };
exports.IconDetailsOrder = IconDetailsOrder;
exports.IconDetailsOrder.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconDetailsOrder;
